module.exports = __webpack_public_path__ + "img/wechat.ad701552.svg";